/*******************************************************************************
 * Copyright     : Copyright (c)  2026 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for any purpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from "react";
import { Modal, ArrowDownIcon } from "@forge/common";

import "./index.scss";

export interface DownloadFileItem {
  id: string;
  sectionLabel: string;
  primaryText: string;
  secondaryText?: string;
  fileName: string;
  downloadUrl: string;
}

interface DownloadFilesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  files: DownloadFileItem[];
  downloadLabel: string;
  onDownload: (file: DownloadFileItem) => void;
}

const DownloadFilesDialog: React.FC<DownloadFilesDialogProps> = ({
  isOpen,
  onClose,
  title,
  description,
  files,
  downloadLabel,
  onDownload,
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      backdrop
      onModalClose={onClose}
      onBackdropClick={onClose}
      className="download-files-dialog-modal"
      title={title}
    >
      <div className="download-files-dialog-content">
        {description && (
          <span className="download-files-dialog-description">
            {description}
          </span>
        )}
        <div className="download-files-dialog-list">
          {files.map((file) => (
            <div className="download-files-dialog-section" key={file.id}>
              <span className="download-files-dialog-section-label">
                {file.sectionLabel}
              </span>
              <div className="download-files-dialog-row">
                <div className="download-files-dialog-row-text">
                  <span className="download-files-dialog-row-primary">
                    {file.primaryText}
                  </span>
                  {file.secondaryText && (
                    <span className="download-files-dialog-row-secondary">
                      {file.secondaryText}
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  className="download-files-dialog-download-link"
                  onClick={() => onDownload(file)}
                >
                  <ArrowDownIcon strokeWidth={2} />
                  {downloadLabel}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default DownloadFilesDialog;

